/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesInviteEmailConnectGameRequestToJSON, FxIdWebFeaturesInviteEmailConnectGameResponseFromJSON, FxIdWebFeaturesInviteEmailInviteRequestToJSON, FxIdWebFeaturesInviteEmailInviteResponseFromJSON, FxIdWebFeaturesInviteEmailInviteStatusRequestToJSON, FxIdWebFeaturesInviteEmailInviteStatusResponseFromJSON, FxIdWebFeaturesInviteUpdateConnectGameInviteRequestToJSON, } from '../models/index';
/**
 *
 */
export class InviteApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesInviteEmailConnectGameEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesInviteEmailConnectGameRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesInviteEmailConnectGameRequest', 'Required parameter "fxIdWebFeaturesInviteEmailConnectGameRequest" was null or undefined when calling fxIdWebFeaturesInviteEmailConnectGameEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/invite/connect_from_game`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesInviteEmailConnectGameRequestToJSON(requestParameters['fxIdWebFeaturesInviteEmailConnectGameRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesInviteEmailConnectGameResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesInviteEmailConnectGameEndpoint(fxIdWebFeaturesInviteEmailConnectGameRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesInviteEmailConnectGameEndpointRaw({ fxIdWebFeaturesInviteEmailConnectGameRequest: fxIdWebFeaturesInviteEmailConnectGameRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesInviteEmailInviteEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesInviteEmailInviteRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesInviteEmailInviteRequest', 'Required parameter "fxIdWebFeaturesInviteEmailInviteRequest" was null or undefined when calling fxIdWebFeaturesInviteEmailInviteEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/invite/email_invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesInviteEmailInviteRequestToJSON(requestParameters['fxIdWebFeaturesInviteEmailInviteRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesInviteEmailInviteResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesInviteEmailInviteEndpoint(fxIdWebFeaturesInviteEmailInviteRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesInviteEmailInviteEndpointRaw({ fxIdWebFeaturesInviteEmailInviteRequest: fxIdWebFeaturesInviteEmailInviteRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesInviteEmailInviteStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesInviteEmailInviteStatusRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesInviteEmailInviteStatusRequest', 'Required parameter "fxIdWebFeaturesInviteEmailInviteStatusRequest" was null or undefined when calling fxIdWebFeaturesInviteEmailInviteStatusEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/invite/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesInviteEmailInviteStatusRequestToJSON(requestParameters['fxIdWebFeaturesInviteEmailInviteStatusRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesInviteEmailInviteStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesInviteEmailInviteStatusEndpoint(fxIdWebFeaturesInviteEmailInviteStatusRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesInviteEmailInviteStatusEndpointRaw({ fxIdWebFeaturesInviteEmailInviteStatusRequest: fxIdWebFeaturesInviteEmailInviteStatusRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesInviteUpdateConnectGameInviteEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesInviteUpdateConnectGameInviteRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesInviteUpdateConnectGameInviteRequest', 'Required parameter "fxIdWebFeaturesInviteUpdateConnectGameInviteRequest" was null or undefined when calling fxIdWebFeaturesInviteUpdateConnectGameInviteEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/invite/update_connect_game_invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesInviteUpdateConnectGameInviteRequestToJSON(requestParameters['fxIdWebFeaturesInviteUpdateConnectGameInviteRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesInviteUpdateConnectGameInviteEndpoint(fxIdWebFeaturesInviteUpdateConnectGameInviteRequest, initOverrides) {
        await this.fxIdWebFeaturesInviteUpdateConnectGameInviteEndpointRaw({ fxIdWebFeaturesInviteUpdateConnectGameInviteRequest: fxIdWebFeaturesInviteUpdateConnectGameInviteRequest }, initOverrides);
    }
}
//# sourceMappingURL=InviteApi.js.map